import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGOS = {
  campus: "/campus-logo.png",
  tmc: "https://customer-assets.emergentagent.com/job_6a302962-5621-4738-8942-ca61cd97acd7/artifacts/hf7v9ehf_TMC_logo_white_PTOTST.png",
};

const api = axios.create({ baseURL: API, withCredentials: true });

// Build an authed media URL usable directly in an <img src> (token as query param).
export const authedMedia = (path) =>
  `${API}${path}${path.includes("?") ? "&" : "?"}auth=${localStorage.getItem("cc_token") || ""}`;
export const studentPhoto = (id) => (id ? authedMedia(`/students/${id}/photo`) : null);
export const bioPhoto = (userId) => (userId ? authedMedia(`/bios/${userId}/photo`) : null);
export const userPhoto = (userId) => (userId ? authedMedia(`/users/${userId}/photo`) : null);

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
